import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate, useLocation } from 'react-router-dom';
import AddComment from './AddComment';
export default function Task_details() {
  const navigate = useNavigate();
  const [listTskMems, setListTskMems] = useState([]);
  const [linkedGoalId, setLinkedGoalId] = useState(0);
  const [linkedGoalname, setLinkedGoalname] = useState('');
  const [linkedGoalpercent, setLinkedGoalpercent] = useState('');
  const [listFilesTask, setListFilesTask] = useState([]);
  const [filterdListProjectMembersArray, setFilterdListProjectMembersArray] = useState([]);
  const [listSelectedMember, setListSelectedMember] = useState([]);
  const [userIsCreator, setuserIsCreator] = useState(false);
  let trackerWindow = null;
  var tskname = '';
  var selectedteamMemCount = 0;

  useEffect(() => {
    var userid = localStorage.getItem('member_id');
    var pr_key = localStorage.getItem('taskid');
    var pid = localStorage.getItem('taskproid');
    var adminaccess = ''
     const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];

      const isSuperAdmin = storedPermissions.includes("task.manage");
      adminaccess = isSuperAdmin ? "Super Admin" : "Member";
    var obj = {
      primary_key: pr_key
    }
    console.log(obj)
    $.ajax({
      url: 'gettskDetails.php',
      type: 'POST',
      data: obj,
      success: function (response) {
        const jsonString = response;
        console.log(jsonString);
        const name = jsonString[0].tsk_proname;
        $('#pro_info').text(name ? name.toUpperCase() : 'Not Available');
        let tskname = jsonString[0].taskname
        $('#tskname').text(tskname ? tskname.toUpperCase() : 'Not Available');
        const prodate = jsonString[0]?.assigneDate ?? 'Not available';
        $('#pro_date_info').text('Date : ' + prodate)
        $('#tsk_details').text(jsonString[0]?.task_details ?? 'Not available')
        $('#edittextarea').val(jsonString[0]?.task_details ?? 'Not available')
        const assignname = jsonString[0].assigneBy;
        $('#asign_name').text(assignname ? assignname.toUpperCase() : 'Not available')
        const assigndate = jsonString[0].assigneDate;
        $('#asign_date').text(assigndate ? assigndate : 'Not available');
        $('#assignbydid').val(jsonString[0]?.assignById ?? "not available");
        setLinkedGoalId(jsonString[0].goal_id);

        setLinkedGoalname(jsonString[0].goal_title)
        setLinkedGoalpercent(jsonString[0].goal_progress)
        var gid = jsonString[0].goal_id ?? '0'
        if (gid < 1 || gid == '0' || gid == '') {
          $('.goalarea').css('display', 'none')
        }

        const tskstatus = jsonString[0].tsk_status;
        $('#tsk_status').text(tskstatus ? tskstatus.toUpperCase() : "not available")
        var timerm = jsonString[0]?.assign_time ?? '0:0';
        var arr = timerm.split(':')
        var hrs = arr[0];
        var mnts = arr[1];
        var totaltime = hrs + ' Hours - ' + mnts + ' minutes';
        $('#tsk_time').text(totaltime);
        var crtid = jsonString[0].assignById;
        const adminmember = localStorage.getItem('user_position');
        if (String(userid) === String(crtid) || adminaccess !== 'Member') {
          setuserIsCreator(true);
        } else {
          $('#tskedit').css('display', 'none');
          $('#tskcomplete').css('display', 'none');
          setuserIsCreator(false);
        }

        var wordkhrs = jsonString[0]?.work_time ?? '0:0';
        var warr = wordkhrs.split(':')
        var hrsw = warr[0];
        var mntsw = warr[1];
        var totaltimew = hrsw + ' Hours - ' + mntsw + ' minutes';
        $('#worktsk_time').text(totaltimew)

        var tskid = jsonString[0]?.id ?? 0;
        var filearr = jsonString[0].files;
        setListFilesTask(filearr);
        console.log('Task ID : '+tskid)

        if (tskid > 0) {
          addTeamFunction(tskid);
        }
        getMemListFortsk();
      }, error: function (xhr, status, error) {
        console.error("AJAX Error:", status, error, xhr.responseText);
      }
    });

  }, [])


  function getMemListFortsk() {
    const active_pro_id = localStorage.getItem('selected_project_id');
    var obj = {
      pro_id: active_pro_id
    }
    $.ajax({
      type: 'POST',
      url: 'getAllProjectMember.php',
      data: obj,
      cache: false,
      success: function (result) {
        var res = result;
        console.log(result)
        if (res !== 'fail' && res !== '') {
          try {
            var tskarr = res;

            // ensure it's an array
            if (Array.isArray(tskarr)) {
              var len = tskarr.length;
              if (len < 1) {
                $('#promem').css('display', 'block');
                $('#no_member_notoce').text('You have not create team for this project. Go to the member area and create a team.')
              } else {
                setFilterdListProjectMembersArray(tskarr);
              }
            } else {
              // if memarr is null or not an array
              setFilterdListProjectMembersArray([]);
            }

          } catch (e) {
            console.error("Invalid JSON from backend:", e);
            $('#memnum').text('0');
            setFilterdListProjectMembersArray([]);
          }
        } else {
          showAlert('Cannot found any member for this project.');
          setFilterdListProjectMembersArray([]);
        }
      },
    });
  }

  function addTeamFunction(tskid) {
    var obj = {
      tsk_id: tskid
    }
    $.ajax({
      url: 'get_tsk_member.php',
      type: 'POST',
      data: obj,
      success: function (response) {
        if (response != 'fail') {
          const jsonString = response;
          console.log(jsonString)
          setListTskMems(jsonString)
        } else {
          showAlert("Cannot find any member for this task")
        }

      }
    });
  }

  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  function retruntolist() {
    let returntomylist = localStorage.getItem('redirectto');
    console.log(returntomylist)
    if (returntomylist === 'mytask') {
      localStorage.setItem('redirectto', 'no');
      navigate('/redirect_mytask');
    } else if (returntomylist === 'admintask') {
      localStorage.setItem('redirectto', 'no');
      navigate('/admin_mytask');
    } else if (returntomylist === 'adminmaintask') {
      localStorage.setItem('redirectto', 'no');
      localStorage.setItem('initialpage', 'task');
      navigate('/redirect_task');
    } else if (returntomylist === 'membertask') {
      localStorage.setItem('initialpage', 'member_task');
      localStorage.setItem('redirectto', 'no');
      navigate('/redirect_task');
    } else {
       navigate(-1);
    }



  }

  function removeTskmember(pr_key) {
    var obj = {
      primary_key: pr_key
    }
    $.ajax({
      type: 'POST',
      url: 'removeTaskMember.php',
      data: obj,
      cache: false,
      success: function (result) {
        if (result != 'fail') {
          navigate('/re_tskdetails');
        } else {
          showAlert('Cannot remove member.');
        }
      },
    });
  }

  function openEditPop() {
    $('.editarea').css('display', 'block');
    $('#tsk_details').css('display', 'none');
  }
  function closeEditArea() {
    $('.editarea').css('display', 'none');
    $('#tsk_details').css('display', 'block');
  }

  function saveUpdateTsk_details() {
    var editcont = $('#edittextarea').val();
    if (editcont == '') {
      alert('Insert text to update')
    } else {
      var pr_key = localStorage.getItem('taskid');
      var obj = {
        tsx_desc: editcont,
        tsk_id: pr_key
      }
      console.log(obj)
      $.ajax({
        type: 'POST',
        url: 'edit_task_details.php',
        data: obj,
        cache: false,
        success: function (result) {
          console.log(result);
          if (result != 'fail') {
            navigate('/re_tskdetails');
          } else {
            showAlert('Cannot remove member.');
          }
        },
      });
    }
  }
  function openAddMemPop() {
    $('#addMempop').css('display', 'block');
  }

  function clsoeMemPop() {
    $('#addMempop').css('display', 'none');
  }

  function selectTheMem(ind) {
    console.log('this is add function')
    var trgid = 'memlist' + ind;
    $('#' + trgid + ' .mem_select').addClass('activeBtn')
    var memberid = filterdListProjectMembersArray[ind].memberid;
    var com_id = filterdListProjectMembersArray[ind].mem_com_id;
    var pro_id = filterdListProjectMembersArray[ind].proid;
    var proname = filterdListProjectMembersArray[ind].proname;
    var member_name = filterdListProjectMembersArray[ind].membername;
    var status_member = filterdListProjectMembersArray[ind].status_member;

    var obj = {
      id: ind,
      memberid: memberid,
      com_id: com_id,
      pro_id: pro_id,
      proname: proname,
      member_name: member_name,
      status_member: status_member
    }
    setListSelectedMember(prevArray => [...prevArray, obj]);
  }
  function removeMem(ind) {
    console.log('this is remove function')
    var trgid = 'memlist' + ind;
    $('#' + trgid + ' .mem_select').removeClass('activeBtn')
    setListSelectedMember(prevArray =>
      prevArray.filter(member => member.id !== ind)
    );
  }

  function saveSelectedNames() {
    var tskmember_arr = listSelectedMember;
    var tskcm = tskname;
    var tskid = localStorage.getItem('taskid');
    var leng = tskmember_arr.length;
    if (selectedteamMemCount < leng) {
      var obj = {
        id: tskmember_arr[selectedteamMemCount].ind,
        memberid: tskmember_arr[selectedteamMemCount].memberid,
        com_id: tskmember_arr[selectedteamMemCount].com_id,
        pro_id: tskmember_arr[selectedteamMemCount].pro_id,
        proname: tskmember_arr[selectedteamMemCount].proname,
        member_name: tskmember_arr[selectedteamMemCount].member_name,
        status_member: tskmember_arr[selectedteamMemCount].status_member,
        tsk_id: tskid,
        tsk_name: tskcm
      }
      $.ajax({
        url: 'save_tsk_member.php',
        type: 'POST',
        data: obj,
        success: function (response) {
          if (response != 'fail') {
            repeat_the_same();
          } else {
            clsoeMemPop();
            showAlert("Cannot save task as one of your member history cannot save")
          }

        }
      });
    } else {
      clsoeMemPop();
      showAlert("All member saved successfully")
      setTimeout(redirectpage, 1500);
    }
  }


  function redirectpage() {
    navigate('/re_tskdetails');
  }

  function repeat_the_same() {
    selectedteamMemCount++;
    saveSelectedNames();
  }

  function removeimg(ind) {
    var obj = {
      primary_key: ind
    }
    $.ajax({
      type: 'POST',
      url: 'removeTaskImage.php',
      data: obj,
      cache: false,
      success: function (result) {
        if (result != 'fail') {
          navigate('/re_tskdetails');
        } else {
          showAlert('Cannot remove image.');
        }
      },
    });
  }

  function opencompletetask() {
    $('#taskcomplete').css('display', 'block')

  }
  function clsoeMemTskComplete() {
    $('#taskcomplete').css('display', 'none')
  }

  function completetask() {
    const today = new Date().toISOString().split('T')[0];
    var pr_key = localStorage.getItem('taskid');

    var obj = {
      pr_key: pr_key,
      comdate: today
    }
    console.log(obj)
    $.ajax({
      type: 'POST',
      url: 'complete_task.php',
      data: obj,
      cache: false,
      success: function (result) {
        console.log(result);
        if (result != 'fail') {
          localStorage.setItem('initialpage', 'task');
          navigate('/redirect_task');
        } else {
          showAlert('Cannot remove member.');
        }
      },
    });

  }

  function openTimeTracker() {
    var userid = localStorage.getItem('member_id');
    var pr_key = localStorage.getItem('taskid');
    var tsk_name = localStorage.getItem('task_name');
    var mem_name = localStorage.getItem('membername');
    var company_id = localStorage.getItem('mem_company_id');
    var pid = localStorage.getItem('taskproid');
    var active_pro_name = localStorage.getItem('selected_project_name');
    var comname = localStorage.getItem('mem_company_name');
    var comlohgo = localStorage.getItem('companylogo');
    var task_details = $('#tsk_details').text();
    const params = new URLSearchParams({
      task_id: pr_key,
      project_id: pid,
      member_id: userid,
      member_name: mem_name,
      mem_com_id: company_id,
      task_name: tsk_name,
      active_pro_name: active_pro_name,
      comname: comname,
      task_details: task_details,
      comlohgo: comlohgo
    });

    const url = `time_tracker.php?${params.toString()}`;
    if (trackerWindow && !trackerWindow.closed) {
      trackerWindow.focus();
      return;
    }
    trackerWindow = window.open(
      url,
      'timeTrackerWindow',
      'width=420,height=420,resizable=no,alwaysRaised=yes,scrollbars=no,toolbar=no,menubar=no,location=no'
    );

  }

  function goForLinkedGoal(goalid) {
    localStorage.setItem('goal_id', goalid);
    navigate('/goal_details');
  }

  return (
    <div>
      <div className='fullwidth'>
        <section className='mainsection border-bottom'>
          <div className='max-container'>
            <div className='headpart'>

              <div className='vl_dsh_one_half'>
                <div className='fullwidth topbackBar'>
                  <button className='back_btn' onClick={retruntolist}><i class="ri-arrow-left-line"> Back</i></button>
                </div>
                <p className='top_info' id="pro_info">Company Name</p>
                <p id="tskname"></p>
                <div className='fullwidth goalarea mt-30'>
                  <p className='pull_left'>Linked Goal: {linkedGoalname}, complited {linkedGoalpercent}% <span id="goalname"></span></p><button className='small_button ml-10' onClick={() => { goForLinkedGoal(linkedGoalId) }}>View Goal</button>
                </div>
              </div>
              <div className='vl_dsh_one_half'>
                <p className='top_info text_right' id="pro_date_info">Date : 02/05/2025</p>
              </div>
            </div>
          </div>
        </section>
        <section className='mainsection'>
          <div className='max-container'>

            <div className='vl_dsh_two_third'>
              <div className='inforow'>
                <h3 id="tskheading" >Details <i id="tskedit" className="ri-edit-2-fill" onClick={openEditPop}></i><i id="tskcomplete" className="ri-checkbox-circle-line" onClick={opencompletetask}></i></h3>
                <button className='workbutton' onClick={openTimeTracker}>Start Work</button>
                <p className='hilightbox'>Click the “Start Work” button to begin the timer and track the time spent on this task.</p>
                <p className='hilighttext' id="tsk_details"></p>
                <div className='editarea'>
                  <button className='clsButton' onClick={closeEditArea}><i class="ri-close-line"></i></button>
                  <textarea id="edittextarea"></textarea>
                  <div className='fullwidth pull_left pt_20'>
                    <button className='saveedit_button' onClick={saveUpdateTsk_details}>Update</button>
                  </div>
                </div>

              </div>
              <div className='inforow'>
                <h3>Assigned By</h3>
                <p id="asign_name"></p>
                <input type="hidden" id="assignbydid" />
              </div>
              <div className='inforow'>
                <h3>Assigned Date</h3>
                <p id="asign_date"></p>
              </div>
              <div className='inforow'>
                <h3>Status</h3>
                <p id="tsk_status"></p>
              </div>
              <div className='inforow'>
                <h3>Time Frame</h3>
                <p id="tsk_time"></p>
              </div>
              <div className='inforow'>
                <h3>Worked</h3>
                <p id="worktsk_time"></p>
              </div>

              <div className='inforow'>
                <h3 className='fullwidth'>Assigned To</h3>

                <p className='fullwidth tskmemlist' id="asign_name_to">
                  {Array.isArray(listTskMems) && listTskMems.map((item, index) => (
                    <span>
                      <span>{item.member_name}</span>
                      {userIsCreator && (
                        <i className='ri-delete-bin-3-fill' onClick={() => { removeTskmember(item.id) }}></i>
                      )}
                    </span>
                  ))}
                </p>
                {userIsCreator && (
                  <button className='text_btn' onClick={openAddMemPop}><i className='ri-add-circle-line'></i>Add Member</button>
                )}
              </div>

              <h3 className='file_list_area_heading'>Files</h3>
              <div className='file_list_area'>
                {listFilesTask.map((item, index) => (
                  <div className='attachmentprev' key={index}>
                    <span><a href={item.link} target="_blank"><img src={item.link} /></a></span>
                    <p><a href={item.link} target="_blank">{item.name.toUpperCase()}{item.type.toUpperCase()}</a></p>
                    <i className='ri-delete-bin-3-fill removeicoImg' onClick={() => { removeimg(item.imgid) }}></i>
                  </div>
                ))}
              </div>
            </div>
            <div className='vl_dsh_one_third'>
              <AddComment />
            </div>
          </div>
        </section>
      </div>
      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>
      <div className='vl_dsh_popup' id="addMempop">
        <div className='memlistarea'>
          <button className='popcls' onClick={clsoeMemPop}>X</button>
          <div className='memlistcontainer'>
            <div className='vl_listing_area'>
              <div className='vl_listing_row'>
                <div className='vl_listing_cell width25'>
                  <h4 className='prj_name'>Member's Name</h4>
                </div>
                <div className='vl_listing_cell width20'>
                  <p>Project Name</p>
                </div>


                <div className='vl_listing_cell width20'>
                  <p>Action</p>
                </div>
              </div>
              {filterdListProjectMembersArray.map((item, index) => (
                <div className='vl_listing_row' id={`memlist${index}`}>
                  <div className='vl_listing_cell width25' key={index}>
                    <h4 className='prj_name' id="memname">{item.membername}</h4>

                    <span >Status : <span id="memrole">{item.status_member}</span></span >
                  </div>


                  <div className='vl_listing_cell width20'>
                    <p>{item.proname}</p>
                  </div>

                  <div className='vl_listing_cell width20 pos_rel'>
                    <button className='mem_select pull_left' onClick={() => { selectTheMem(index) }}>Select Member</button>
                    <i className='ri-delete-bin-3-fill removeico' onClick={() => { removeMem(index) }}></i>
                  </div>
                </div>
              ))}
            </div>
            <div className='btn_holder'>
              <button className='save_btn pull_right' onClick={saveSelectedNames}>Add Members</button>
            </div>
          </div>
        </div>
      </div>

      <div className='vl_dsh_popup' id="taskcomplete">
        <div className='memlistareashort'>

          <div className='memlistcontainer'>
            <p>Are you sure this task has been completed?</p>
            <div className='vl_dsh_buttonholder'>
              <button onClick={completetask}>Yes</button>
              <button className='closebtn' onClick={clsoeMemTskComplete}>Cancel</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}
